import { Component, Input, OnInit } from '@angular/core';
import { ReportingSetService } from 'src/app/dashboard/modules/reporting-set/reporting-set.service';
import { ModuleManager } from 'src/shared/models/module-manager';
import { FilterableField, ReportingSetDefinition } from 'src/shared/models/pipeline-config/reporting-sets.models';

@Component({
    selector: 'cv-reportingset-dynamic-filters-wrapper',
    templateUrl: './reportingset-dynamic-filters-wrapper.component.html',
    styleUrls: ['./reportingset-dynamic-filters-wrapper.component.scss']
})
export class ReportingsetDynamicFiltersWrapperComponent implements OnInit {
    @Input() moduleManager: ModuleManager;
    @Input() reportingSetDefinitions: string[];

    public reportingSetFilterableFields: { [FieldName: string]: FilterableField };
    public definitions: ReportingSetDefinition[] = null;
    public selectedReports: ReportingSetDefinition[] = null;

    constructor(private service: ReportingSetService) {}

    async ngOnInit() {
        await this.loadData();
    }

    public async loadData() {
        const response = await this.service.loadReportingSetDefinitions();
        this.definitions = response.map(d => d.ReportingSetDefinition);
        this.selectedReports = this.definitions?.filter(set => this.reportingSetDefinitions.includes(set.ReportingSetName));
        this.reportingSetFilterableFields = {};
        this.selectedReports?.forEach(set => {
            Object.assign(this.reportingSetFilterableFields, set.ReportFilterableFields);
        });
    }
}
